// reducers/identity/guestDocumentReducer.ts
import {
  FETCH_PASSPORT_DATA_REQUEST,
  FETCH_PASSPORT_DATA_SUCCESS,
  FETCH_PASSPORT_DATA_FAILURE,
  FETCH_GUEST_DATA_REQUEST,
  FETCH_GUEST_DATA_SUCCESS,
  FETCH_GUEST_DATA_FAILURE,
  SAVE_GUEST_DOCUMENT_REQUEST,
  SAVE_GUEST_DOCUMENT_SUCCESS,
  SAVE_GUEST_DOCUMENT_FAILURE,
  DELETE_SINGLE_DOCUMENT_REQUEST,
  DELETE_SINGLE_DOCUMENT_SUCCESS,
  DELETE_SINGLE_DOCUMENT_FAILURE,
  DELETE_GROUP_DOCUMENT_REQUEST,
  DELETE_GROUP_DOCUMENT_SUCCESS,
  DELETE_GROUP_DOCUMENT_FAILURE,
  DELETE_MORE_GUEST_REQUEST,
  DELETE_MORE_GUEST_SUCCESS,
  DELETE_MORE_GUEST_FAILURE,
  SCAN_PASSPORT_REQUEST,
  SCAN_PASSPORT_SUCCESS,
  SCAN_PASSPORT_FAILURE,
  SCAN_ID_CARD_REQUEST,
  SCAN_ID_CARD_SUCCESS,
  SCAN_ID_CARD_FAILURE,
  GuestDocumentActionTypes,
  CLEAR_SCAN_ID_CARD_STATE,
} from '../../actions/identity/guestDocumentActions';

interface GuestDocumentState {
  // Passport Data
  passportLoading: boolean;
  passportData: { [key: string]: any[] };
  passportError: string | null;

  // Guest Data
  guestLoading: boolean;
  guestData: any[];
  guestError: string | null;

  // Save Document
  saveLoading: boolean;
  saveError: string | null;
  saveSuccess: boolean;

  // Delete Single
  deleteSingleLoading: boolean;
  deleteSingleError: string | null;

  // Delete Group
  deleteGroupLoading: boolean;
  deleteGroupError: string | null;

  // Delete More Guest
  deleteMoreGuestLoading: boolean;
  deleteMoreGuestError: string | null;

  // Scan Passport
  scanPassportLoading: boolean;
  scanPassportData: any | null;
  scanPassportError: string | null;

  // Scan ID Card
  scanIdCardLoading: boolean;
  scanIdCardData: any | null;
  scanIdCardError: string | null;
}

const initialState: GuestDocumentState = {
  passportLoading: false,
  passportData: {},
  passportError: null,

  guestLoading: false,
  guestData: [],
  guestError: null,

  saveLoading: false,
  saveError: null,
  saveSuccess: false,

  deleteSingleLoading: false,
  deleteSingleError: null,

  deleteGroupLoading: false,
  deleteGroupError: null,

  deleteMoreGuestLoading: false,
  deleteMoreGuestError: null,

  scanPassportLoading: false,
  scanPassportData: null,
  scanPassportError: null,

  scanIdCardLoading: false,
  scanIdCardData: null,
  scanIdCardError: null,
};

const guestDocumentReducer = (
  state = initialState,
  action: GuestDocumentActionTypes
): GuestDocumentState => {
  switch (action.type) {
    case FETCH_PASSPORT_DATA_REQUEST:
      return { ...state, passportLoading: true, passportError: null };
    case FETCH_PASSPORT_DATA_SUCCESS:
      return { ...state, passportLoading: false, passportData: action.payload, passportError: null };
    case FETCH_PASSPORT_DATA_FAILURE:
      return { ...state, passportLoading: false, passportError: action.payload };

    case FETCH_GUEST_DATA_REQUEST:
      return { ...state, guestLoading: true, guestError: null };
    case FETCH_GUEST_DATA_SUCCESS:
      return { ...state, guestLoading: false, guestData: action.payload, guestError: null };
    case FETCH_GUEST_DATA_FAILURE:
      return { ...state, guestLoading: false, guestError: action.payload };

    case SAVE_GUEST_DOCUMENT_REQUEST:
      return { ...state, saveLoading: true, saveError: null, saveSuccess: false };
    case SAVE_GUEST_DOCUMENT_SUCCESS:
      return { ...state, saveLoading: false, saveError: null, saveSuccess: true };
    case SAVE_GUEST_DOCUMENT_FAILURE:
      return { ...state, saveLoading: false, saveError: action.payload, saveSuccess: false };

    case DELETE_SINGLE_DOCUMENT_REQUEST:
      return { ...state, deleteSingleLoading: true, deleteSingleError: null };
    case DELETE_SINGLE_DOCUMENT_SUCCESS:
      return { ...state, deleteSingleLoading: false, deleteSingleError: null };
    case DELETE_SINGLE_DOCUMENT_FAILURE:
      return { ...state, deleteSingleLoading: false, deleteSingleError: action.payload };

    case DELETE_GROUP_DOCUMENT_REQUEST:
      return { ...state, deleteGroupLoading: true, deleteGroupError: null };
    case DELETE_GROUP_DOCUMENT_SUCCESS:
      return { ...state, deleteGroupLoading: false, deleteGroupError: null };
    case DELETE_GROUP_DOCUMENT_FAILURE:
      return { ...state, deleteGroupLoading: false, deleteGroupError: action.payload };

    case DELETE_MORE_GUEST_REQUEST:
      return { ...state, deleteMoreGuestLoading: true, deleteMoreGuestError: null };
    case DELETE_MORE_GUEST_SUCCESS:
      return { ...state, deleteMoreGuestLoading: false, deleteMoreGuestError: null };
    case DELETE_MORE_GUEST_FAILURE:
      return { ...state, deleteMoreGuestLoading: false, deleteMoreGuestError: action.payload };

    case SCAN_PASSPORT_REQUEST:
      return { ...state, scanPassportLoading: true, scanPassportError: null, scanPassportData: null };
    case SCAN_PASSPORT_SUCCESS:
      return { ...state, scanPassportLoading: false, scanPassportData: action.payload, scanPassportError: null };
    case SCAN_PASSPORT_FAILURE:
      return { ...state, scanPassportLoading: false, scanPassportError: action.payload };

    case SCAN_ID_CARD_REQUEST:
      return { ...state, scanIdCardLoading: true, scanIdCardError: null, scanIdCardData: null };
    case CLEAR_SCAN_ID_CARD_STATE:
      return { ...state, scanIdCardLoading: true, scanIdCardError: null, scanIdCardData: null };
    case SCAN_ID_CARD_SUCCESS:
      return { ...state, scanIdCardLoading: false, scanIdCardData: action.payload, scanIdCardError: null };
    case SCAN_ID_CARD_FAILURE:
      return { ...state, scanIdCardLoading: false, scanIdCardError: action.payload };

    default:
      return state;
  }
};

export default guestDocumentReducer;

